export default "__VITE_ASSET__DqqxO8Fj__"